const CHUNK_BYTES = 4 * 1024 * 1024;

function bytesToHex(bytes: Uint8Array): string {
  return [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('');
}

export async function hashFileVersioned(file: Blob): Promise<string> {
  const chunkDigests: Uint8Array[] = [];
  for (let offset = 0; offset < file.size; offset += CHUNK_BYTES) {
    const chunk = await file.slice(offset, Math.min(file.size, offset + CHUNK_BYTES)).arrayBuffer();
    chunkDigests.push(new Uint8Array(await crypto.subtle.digest('SHA-256', chunk)));
  }
  const header = new TextEncoder().encode(`atp-sha256-chunks-v1:${file.size}:${chunkDigests.length}:`);
  const joined = new Uint8Array(header.length + chunkDigests.length * 32);
  joined.set(header);
  chunkDigests.forEach((digest, index) => joined.set(digest, header.length + index * 32));
  return `atp1:${bytesToHex(new Uint8Array(await crypto.subtle.digest('SHA-256', joined)))}`;
}
